import {UserInput} from "../../http/protocol";
import {UseFormRegister, UseFormSetValue} from "react-hook-form/dist/types/form";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {useFormContext} from "react-hook-form";
import {selectText, usePrevious} from "../../user/ui/utils";
import * as React from "react";
import {useEffect, useState} from "react";
import PhoneInput from "react-phone-input-2";
import {InputError} from "./InputError";
import { AppState } from "../../RootReducer";
import { useSelector } from "react-redux";
import { PHONE_INPUT_CLASSNAME, PHONE_INPUT_TABINDEX, setTabIndex } from "../../utils/tabindex";

export const UserDetailsPhoneInput = (props: { input: UserInput, setValue: UseFormSetValue<any>, name: string, register: UseFormRegister<any>, errors: FieldErrors<any>, options: RegisterOptions , handleFocus: any}) => {
    let {getValues} = useFormContext();
    const {input, name, register, errors, options, setValue} = props;
    const hasError = !!errors[name]
    const {nameText, invalidText, helpText} = selectText(name);
    let def = "";
    if (typeof getValues(name as any) === "string") {
        def = getValues(name as any) as string;
    }
    const [phone, setPhone] = useState(def);
    const country = useSelector((app: AppState) => app.user.user?.country) 
    let prevError = usePrevious(errors?.[name]?.message ?? "");
    let prevPhone = usePrevious(phone);

    React.useEffect(()=>{
            setTabIndex(PHONE_INPUT_CLASSNAME, PHONE_INPUT_TABINDEX)
    },[])

    useEffect(() => {

        if(phone != prevPhone || (errors?.[name]?.message) != "") {
            let reValidate = false;
            if(!prevPhone) {
                reValidate = false;
            } else if(phone != prevPhone) {
                reValidate = true;
            } else if((errors?.[name]?.message ?? "") == "") {
                reValidate = true;
            }
            setValue(name, phone, { shouldValidate :  reValidate});
        }
    }, [phone, prevPhone]);

    return (
        <div onBlur={props.handleFocus} className={"form-group " + (hasError ? "has-error" : "")}>
            <label id={name} className={"forms-label"} htmlFor={name}>{nameText}</label>
            <input type={"text"} {...register(name, options)} style={{display: "none"}}/>
            <PhoneInput
                onFocus={props.handleFocus} 
                value={phone}
                country={country?.toLowerCase() ?? ""}
                onChange={(data) => setPhone(data)}
                placeholder={"1 702 123 4567"}
                searchPlaceholder={"Search"}
                enableSearch={true}
                defaultMask={"... ... ... ... ..."}
                alwaysDefaultMask={true}
            />
            {helpText.length > 0 && !hasError && <span className="help-block">{helpText}</span>}
            {hasError && <InputError name={name} errors={errors} invalidText={invalidText}/>}
        </div>
    )
}